<template>
  <div class="modal_root clearfix" @click="outsideClick($event)"
    :class="{shown: modalStatus}" data-closer>
    <div class="wrapper">
      <div :class="{modal_bg: true, shown: modalStatus}">
        <div class="content_wrapper">
          <div class="modal_header">
            <h1>{{modalData.title}}</h1>
            <i class="fa fa-times fa-fw" data-closer></i>
          </div>
          <div class="separator"></div>
          <div class="modal_body" v-html="modalData.body"></div>
          <div class="separator" v-if="footer"></div>
          <div class="modal_footer" v-if="footer">
            <Button v-for="(button, index) in modalData.footer"
              :key="index"
              :href="button.href"
              :alternate="button.isAlt"
              :data_closer="true">
              {{button.text}}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../components/Button';

export default {
  name: 'Modal',
  components: {
    Button,
  },
  computed: {
    modalStatus() {
      return this.$store.getters.getModalState;
    },
    modalData() {
      return this.$store.getters.getModalData;
    },
    footer() {
      return this.modalData.footer.length > 0;
    },
  },
  methods: {
    outsideClick(e) {
      if (e.target.dataset.closer !== undefined) {
        this.$store.commit('closeModal');
      }
    },
  },
};
</script>

<style lang="scss">
@import '../styles/modal_inside.scss';
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
.modal_root {
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(#000, .65);
  padding-top: 60px;
  flex: 1;
  display: flex;
  visibility: hidden;
  flex-direction: column;
  justify-content: center;
  transition: all .2s ease;
  &.shown {
    display: flex;
    opacity: 1;
    visibility: visible;
  }
  .wrapper {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    max-height: calc(100% - 5vw);
    min-width: 50%;
    .modal_bg {
      box-sizing: border-box;
      background: $text_gray;
      overflow-y: auto;
      padding: 25px 30px 0;
      box-shadow: 0 3px 6px rgba(#000, .35);
      border-radius: 2px;
      display: flex;
      flex-direction: column;
      color: $dark_bg;
      width: 90%;
      max-width: 1200px;
      min-width: 300px;
      margin: 0 auto;
      opacity: 1;
      transform: translateY(-100%);
      transition: transform .3s ease;
      &.shown {
        transform: translateY(0);
      }
      .content_wrapper {
        .modal_header {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          h1 {
            margin: 0;
            font-weight: 500;
          }
          i {
            font-size: 30px;
            align-self: center;
            cursor: pointer;
            &:hover {
              color: #000;
            }
          }
        }
        .separator{
          background: darken($text_gray, 10);
          padding: 1px;
          border-radius: 2px;
          margin-top: 10px;
        }
        .modal_footer {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          padding: 25px 0;
          .btn {
            width: auto;
            margin-right: 20px;
            .trigger {
              a {
                padding: 10px 20px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .modal_body {
    .project_icon {
      width: 180px;
      height: 180px;
    }
  }
}

@media screen and (max-width: 700px) {
  .modal_body {
    .project_icon {
      width: 160px;
      height: 160px;
    }
  }
}

@media screen and (max-width: 600px) {
  .modal_body {
    .project_icon {
      width: 140px;
      height: 140px;
    }
  }
}

@media screen and (max-width: 500px) {
  .modal_body {
    .project_icon {
      width: 100px;
      height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue